import { MoongateLoader } from "@assets";
import { Player } from "@lottiefiles/react-lottie-player";

const Loader = ({ size: size = 48 }: { size?: number }) => {
  return (
    <div className="p-8">
      <Player
        autoplay
        loop
        src={MoongateLoader}
        style={{ height: `${size}px`, width: `${size}px` }}
      ></Player>
    </div>
  );
};

export default Loader;
